const useStoreUpdate = (dispatch, reducer, object) => {
  const updateFormObject = (e) => {
    const name = e.target.name
    const value = e.target.value
    dispatch(reducer({ ...object, [name]: value }))
  }

  const updateFormObjectProp = (prop, value) => {
    dispatch(reducer({ ...object, [prop]: value }))
  }

  return [updateFormObject, updateFormObjectProp]
}

export default useStoreUpdate